export enum AssignmentRowType {
  Assignment = 'Assignment',
  RequestedResource = 'RequestedResource',
  UnassignedAssignment = 'UnassignedAssignment',
  TimeOff = 'TimeOff'
}
